<script setup lang="ts">
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

const router = useRouter();
const showPrompt = ref(false);

type DasboardSidebarUserProps = {
  avatar: string | null;
  name: string;
  role: string;
  href: string;
};

const props = defineProps<DasboardSidebarUserProps>();
const avatarSafe = computed(() => props.avatar ?? undefined);

const getInitials = (name: string): string => {
  return name
    .split(" ")
    .map((part) => part.charAt(0).toUpperCase())
    .slice(0, 2)
    .join("");
};

const SignOut = () => {
  showPrompt.value = false;
  router.push(props.href);
};
</script>

<template>
  <div
    class="flex cursor-pointer items-center justify-between"
    @click="showPrompt = true"
  >
    <div class="hidden items-center gap-2 lg:flex">
      <Avatar class="bg-white">
        <AvatarFallback class="bg-white text-black filter">
          {{ getInitials(name) }}
        </AvatarFallback>
        <AvatarImage v-if="avatarSafe" :src="avatarSafe" />
      </Avatar>

      <div class="flex h-full flex-col justify-start">
        <span class="label-medium text-white/80">{{ name }}</span>
        <span class="label-small text-white/50">{{ role }}</span>
      </div>
    </div>

    <Icon
      class="flex-1 text-white lg:flex-initial"
      name="ion:log-out-outline"
      size="24"
    />
  </div>

  <!-- Modal de Confirmação -->
  <AppPrompt
    v-model:open="showPrompt"
    title="Sair do Sistema"
    description="Tem certeza que deseja sair?"
    @confirm="SignOut"
    @cancel="showPrompt = false"
  />
</template>

<style scoped></style>
